module.exports = __webpack_public_path__ + "static/media/2022-may-image-banner.ed9aa2e0.png";